<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'lg'" :centered="true" :btn_cancel="true"
    :btn_ok="true" :booTitile="true">
    <div class="container">
      <CRow>
        <CCol sm="12" md="12" lg="6">
          <CInput label="Código de Producto" placeholder="Digite de barras mediante la lectora" v-model="searchBarcode"
            @keypress.enter="filterProductoBarcode" />
        </CCol>
        <CCol sm="12" md="12" lg="6">
          <CInput label="Buscar Producto" type="search" v-model="searchQuery" placeholder="Digite nombre de producto.."
            @input="filterProducts" />
          <ul v-if="filteredProducts.length > 0" class="list-group my-2 tamanio" style="max-height: 180px; overflow-y: auto;">
            <li v-for="product in filteredProducts" :key="product.id"
              class="list-group-item d-flex justify-content-between align-items-center">
              {{ product.product_unit.product.name }} - {{ product.product_unit.unit.name }}
              <button @click="addProductToTable(product)" class="btn btn-sm bg-purple text-white">Agregar</button>
            </li>
          </ul>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <div class="table-responsive">
            <table id="dataTableLists" class="table table-sm table-hover table-bordered dt-responsive nowrap"
              style="width: 100%">
              <thead>
                <tr>
                  <th width="60">N°</th>
                  <th>Producto</th>
                  <th>Cantidad</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, index) in selectedProducts" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ product.name }}</td>
                  <td><input v-model="product.quantity" type="number" min="1" @input="validateStock(product)"
                      class="form-control" />
                  </td>
                  <td>
                    <button @click="removeProduct(index)" class="btn btn-danger btn-sm">
                      <i class="fas fa-trash"></i> Eliminar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCol>
      </CRow>
    </div>
    <template #footer>
      <CButton class="btn-secondary" @click="mtdClose(false)" :style="{ color: 'black' }">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </CButton>
      <CButton @click="type === 'cortesy' ? saveCourtesy() : saveProduct()"
        :style="{ backgroundColor: '#00003a', color: 'white' }">
        Guardar
      </CButton>
    </template>
  </CModal>
</template>

<script>
import CModal from "../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";
import cSelectForm from "../../shared/inputs/cSelect.vue";

export default {
  name: "c-addcourtesy-modal",
  components: {
    CModal,
    cSelectForm,
  },
  data() {
    return {
      swal: null,
      products: [],
      data_product: [],
      searchQuery: "",
      searchBarcode: "",
      filteredProducts: [],
      filteredProductsBarcode: [],
      selectedProducts: [],
    }
  },
  props: {
    title: String,
    boo_modal: Boolean,
    id: Number,
    dataProducts: Array,
    type: String
  },
  watch: {
    boo_modal(newVal) {
      if (newVal) {
        this.mtdGetProduct();
        this.showProduct();
      }
    },
    dataProducts(newVal) {
      if (newVal) {
        this.selectedProducts = newVal;
      }
    }
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose(refresh) {
      this.searchQuery = "";
      this.searchBarcode = "";
      this.filteredProducts = [];
      this.selectedProducts = [];
      this.$emit("closeModalCourtesy", refresh);
    },
    showProduct() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/sales/byProduct/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.data.forEach((arr) => {
            const { stock, product_unit } = arr;
            this.data_product.push({
              label: product_unit.product.name,
              value: product_unit.product.id,
              price: product_unit.product.price[0].sale_price,
              value_unit: product_unit.unit.id,
              label_unit: product_unit.unit.name,
              barcodes: product_unit.product.barcode,
              stock: stock,
            });
          });
        })
        .catch((errors) => { });
    },
    mtdGetProduct() {
      this.get({
        url: this.$store.getters.get__url + "/courtesy/byProduct/" + this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {  
          this.products = response.data.data;
          if (this.searchQuery !== "") {
            this.filteredProducts = this.products;
          }
        })
        .catch((errors) => { });
    },
    filterProducts() {
      if (this.searchQuery === "") {
        this.filteredProducts = 0;
      } else {
        this.filteredProducts = this.products.filter(product =>
          product.product_unit.product.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      }
    },
    filterProductoBarcode() {
      if (this.searchBarcode) {
        const matchingProducts = this.data_product.filter(product =>
          product.barcodes.some(barcode => barcode.name === this.searchBarcode)
        );

        if (matchingProducts.length > 0) {
          this.addProductoBarcode(matchingProducts[0]); // Pasar solo el primer producto encontrado
        } else {
          Swal.fire({
            title: "Código de barra no encontrado",
            icon: "warning",
          });
        }
      }
    },
    addProductoBarcode(product) {
      // Verificar si el producto ya está en la lista seleccionada
      const existingProduct = this.selectedProducts.find(
        (p) => p.product_id === product.value && p.product_unit_id === product.value_unit
      );

      if (existingProduct) {
        // Incrementar la cantidad si no excede el stock
        if (existingProduct.quantity < product.stock) {
          existingProduct.quantity += 1;
        } else {
          Swal.fire({
            title: "La cantidad excede del stock disponible",
            icon: "warning",
          });
        }
      } else {
        // Agregar un nuevo producto a la lista
        const newProduct = {
          product_id: product.value,
          name: product.label,
          product_unit_id: product.value_unit,
          price: product.price,
          quantity: 1,
          stock: product.stock,
        };
        this.selectedProducts.push(newProduct);
      }

      // Limpiar el campo de búsqueda
      this.searchBarcode = "";
    },
    addProductToTable(product) {
      const format = {
        product_id: product.product_unit.product.id,
        price: product.product_unit.product.price[0].sale_price,
        name: product.product_unit.product.name,
        state: 1,
        campu_id: this.$store.getters.get_campu.id,
        quantity: 1,
        priceCourtesy: 0,
        product_unit_id: product.product_unit.id,
        stock: product.stock
      }
      
      if (Number(format.quantity) > Number(format.stock)) {
        Swal.fire({
          title: "La cantidad excede del stock disponible",
          icon: "warning",
          confirmButtonText: "Aceptar"
        });
      } else {
        if (this.selectedProducts.some(p => p.product_id === format.product_id)) {
          Swal.fire({
            title: "Producto ya agregado",
            text: "Este producto ya está en la lista.",
            icon: "warning",
            confirmButtonText: "Aceptar"
          });
        } else {
          this.selectedProducts.push(format);
        }
      }

      this.searchQuery = "";
      this.filteredProducts = [];
    },
    removeProduct(index) {
      this.selectedProducts.splice(index, 1);
    },
    validateStock(product) {
      const quantity = Number(product.quantity); // Asegurarte que sea un número
      const stock = Number(product.stock); // Asegurarte que sea un número
      if (quantity > stock) {
        product.quantity = stock;
        Swal.fire({
          title: "Cantidad excedida",
          text: `El stock disponible es ${stock}.`,
          icon: "warning",
          confirmButtonText: "Aceptar"
        });
      }
    },
    saveCourtesy() {
      const productsCourtesy = this.selectedProducts.map(product => {
        return {
          product_id: product.product_id,
          campu_id: product.campu_id,
          price: product.price,
          quantity: product.quantity,
          name: product.name,
          state: 1,
          priceCourtesy: 0,
          product_unit_id: product.product_unit_id,
          stock: product.stock,
        };
      });

      const data = {
        courtesy: productsCourtesy,
        quote_id: this.$props.id,
      }

      this.post({
        url: this.$store.getters.get__url + "/courtesy/storeCourtesy",
        token: this.$store.getters.get__token,
        params: data
      }).then((response) => {
        if (response.statusCode == 200) {
          Swal.fire({
            title: "Cortesía registrada",
            icon: "success",
          });
          this.mtdClose(true);
        } else {
          Swal.fire({
            title: "Error al resgistrar",
            icon: "danger",
          });
        }
      });
    },
    saveProduct() {
      // Lógica para guardar producto
      const products = this.selectedProducts.map(product => {
        return {
          product_id: product.product_id,
          campu_id: product.campu_id,
          price: product.price,
          quantity: product.quantity,
          name: product.name,
          state: 1,
          // priceCourtesy: 0,
          product_unit_id: product.product_unit_id,
          stock: product.stock,
        };
      });
      const data = {
        products: products,
        quote_id: this.$props.id,
      }
      this.post({
        url: this.$store.getters.get__url + "/cita/storeProduct",
        token: this.$store.getters.get__token,
        params: data
      }).then((response) => {
        if (response.statusCode == 200) {
          Swal.fire({
            title: "Productos Registrados",
            icon: "success",
          });
          this.mtdClose(true);
        } else {
          Swal.fire({
            title: "Error al resgistrar",
            icon: "danger",
          });
        }
      });
    }
  }
}
</script>

<style scoped>
.bg-purple {
  background-color: #00003a;
}
.color-white {
  color: white;
}
.tamanio {
  max-height: 180px;
  overflow-y: auto;
}
</style>
